<template>
<!--  关于我们页面-->
  <div class="aboutsUs">
    <HeadNav/>
    <div class="d2">
    <span class="title">CryptoDAO{{langUtil(76)}}</span>
    <div class="d1">
      {{langUtil(77)}}
    </div>
      <div class="d1">{{langUtil(78)}}</div>
    </div>
  </div>
</template>

<script>
  import HeadNav from "../components/HeadNav";
  export default {
    name: "aboutsUs",
    components: {
      HeadNav
    },
  }
</script>

<style lang="less" scoped>
.d1{
  font-size: 12px;
  color: black;
  line-height: 2.6;
  text-indent: 2em;
  margin-top: 10px;
}
  .title{
    font-size: 12px;
    color: black;
    background-color: #EEFFCC;
    border: 1px solid #BAED54;
    border-radius: 17px;
    padding: 3px 10px;
  }
  .d2{
    padding: 20px;
  }
</style>
